import * as types from "./types";
import { createReducer } from "../../util/index";

const initialState = {
    loading: false,
    data: [],
};

const settlementReducer = createReducer(initialState)({
    [types.SETTLEMENT_LIST]: (state, action) => ({
        ...state,
        settlement_list: action.payload
    }),

    [types.SETTLEMENT_DROPDOWN]: (state, action) => ({
        ...state,
        settlement_dropdown: action.payload
    }),

    [types.SETTLEMENT_BALANCE]: (state, action) => ({
        ...state,
        settlement_balance: action.payload
    }),

    [types.SETTLEMENT_CREATE]: (state, action) => ({
        ...state,
        settlement_create: action.payload
    })
});

export default settlementReducer;